import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import useIsMobile from '../../../hooks/useIsMobile'

const StoreBlockContacts = ({ storeData }) => {
  const isMobile = useIsMobile()

  const contact = storeData.data.contact_info

  let backgroundImageUrl = storeData.data.about_images?.[0]?.url
  if (!backgroundImageUrl) {
    backgroundImageUrl = '/img/placeholder-store-about.png'
  }

  return (
    <div className="bg-light br-3 overflow-hidden">
      <Row>
        <Col
          xs={12} md={5} xl={4}
          className="d-flex flex-column justify-content-center"
        >
          <div className="w-100 p-4 px-md-5">
            <div className={'d-flex flex-column gap-2'}>
              <h2 className="fs-3">
                About Seller
              </h2>
              <div
                style={{ whiteSpace: 'break-spaces' }}
              >
                {storeData.data.about_text}
              </div>
            </div>

            {(contact.name || contact.phone_number || contact.email) && (
              <div className={'mt-5 d-flex flex-column gap-2'}>
                {contact.name && (
                  <div>
                    {contact.name}
                  </div>
                )}
                {contact.phone_number && (
                  <div>
                    <a href={`tel:${contact.phone_number}`}>{contact.phone_number}</a>
                  </div>
                )}
                {contact.email && (
                  <div>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
        <Col
          xs={12} md={7} xl={8}
        >
          <div style={{ height: isMobile ? 200 : 500 }}>
            {backgroundImageUrl && (
              <Image
                src={backgroundImageUrl}
                alt={storeData.name + ' About Us | Ivy Store'}
                className={'w-100 h-100 bg-light'}
                fluid
                style={{ objectFit: 'cover' }}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default StoreBlockContacts